import { Fragment, useState } from "react";
import TransactionCard from "../cards/finances/TransactionCard";
import TransactionDetailsModal from "../popup/finances/TransactionDetailsModal";
import BaseCarousel from "./common/BaseCarousel";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../utils/schemas/language/pages/personalFinancesSchema";

function LatestTransactionsCarousel({ rows = [], onTransactionUpdate }) {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [transactionDetailsModal, setTransactionDetailsModal] = useState(false);

  // Take up to 6 items as a flat array
  const latestRows = rows.slice(0, 6);

  const openTransactionDetailsModal = (item) => {
    setSelectedTransaction(item);
    setTransactionDetailsModal(true);
  };

  const handleTransactionUpdate = (updatedTransaction) => {
    setSelectedTransaction(updatedTransaction);
    if (onTransactionUpdate) {
      onTransactionUpdate(updatedTransaction);
    }
  };

  return (
    <Fragment>
      <div className="latest-transactions-carousel-container mobile-reset-standard-card-container  mobile-white-box">
        <BaseCarousel
          title={content.transactions.latest_title}
          items={latestRows} // Pass flat array directly
          showBorder={false}
          emptyMsg={content.transactions.empty}
          previousAlt={content.global.previous}
          nextAlt={content.global.next}
          renderItem={(item, index) => (
            <TransactionCard
              key={item.uuid || item.id || index}
              transaction={item}
              onClick={() => openTransactionDetailsModal(item)}
            />
          )}
        />
      </div>

      {transactionDetailsModal && (
        <TransactionDetailsModal
          transaction={selectedTransaction}
          onTransactionUpdate={handleTransactionUpdate}
          copy={content.transactions.details}
          commonCopy={content.global}
          onClose={() => {
            setSelectedTransaction(null);
            setTransactionDetailsModal(false);
          }}
        />
      )}
    </Fragment>
  );
}

export default LatestTransactionsCarousel;
